import { useTranslation } from "react-i18next";
import { Eye, Target } from "lucide-react";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white hairline scroll-mt-24">
      <div className="container-page">
        <div className="mb-14 max-w-3xl">
          <span className="kicker mb-4">{t("about.label")}</span>
          <h2 className="text-4xl tablet:text-3xl mobile:text-2xl font-semibold tracking-[-0.02em] text-black">
            {t("about.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 tablet:grid-cols-1 gap-14 tablet:gap-10">
          <div className="space-y-6">
            <p className="text-lg tablet:text-base text-gray-600 leading-relaxed max-w-[65ch]">
              {t("about.description")}
            </p>
            <p className="text-base text-gray-600 leading-relaxed max-w-[65ch]">
              {t("about.description2")}
            </p>
          </div>

          <div className="space-y-5">
            <div className="rounded-xl border border-blueLight bg-blueLight p-7 transition-[box-shadow,transform] duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 rounded-lg bg-white flex items-center justify-center shrink-0">
                  <Eye className="w-4 h-4 text-textBlue" aria-hidden="true" />
                </span>
                <h3 className="text-xl font-semibold text-textBlue">{t("about.vision")}</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">{t("about.visionText")}</p>
            </div>

            <div className="rounded-xl border border-backgroundTeal bg-backgroundTeal p-7 transition-[box-shadow,transform] duration-300 hover:shadow-lg hover:-translate-y-1">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 rounded-lg bg-white flex items-center justify-center shrink-0">
                  <Target className="w-4 h-4 text-textBlue" aria-hidden="true" />
                </span>
                <h3 className="text-xl font-semibold text-textBlue">{t("about.mission")}</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">{t("about.missionText")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
